<template>
  <resource-loader :task="task" :resource="modelValue">
    No social platforms found.
  </resource-loader>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { SocialSite } from '@/type';
import { HasTaskMixin } from '@/mixins';
import ResourceLoader from '@/components/loading/ResourceLoader.vue';
import repository from './site-repository';

interface Data {
  task: Promise<SocialSite[]>|undefined,
}

export default defineComponent({
  emits: ['loaded', 'update:modelValue'],
  mixins: [HasTaskMixin],
  components: {
    ResourceLoader,
  },
  props: {
    modelValue: Array as () => SocialSite[],
  },
  data(): Data {
    return {
      task: undefined,
    };
  },
  methods: {
    load() {
      this.task = repository.findAll();
      this.task.then((socialSites) => {
        this.$emit('update:modelValue', socialSites);
        this.$emit('loaded', socialSites);
      });
    },
  },
  created() {
    this.load();
  },
});
</script>
